exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__wrapper___2DK0U{height:calc(100vh - 55px - 122px)}", ""]);

// Exports
exports.locals = {
	"wrapper": "styles__wrapper___2DK0U"
};